/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'antd';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';

const { Item } = Form;

export const WithAntdFieldLayout = (WrappedComponent) => {
  return React.forwardRef((props, ref) => {
    const {
      name,
      label,
      field,
      form,
      meta,
      required,
      layoutClasses,
      help,
      hasFeedback,
      tooltip,
      layout,
      ...rest
    } = props;

    const validateStatus = React.useMemo(() => {
      const hasError = get(meta, `error`);
      if (meta && name) {
        if (meta.touched && hasError) {
          return 'error';
        }
        if (meta.touched && meta.warning) {
          return 'warning';
        }
        if (meta.touched && meta.success) {
          return 'success';
        }
      }
      return null;
    }, [meta]);

    const error = React.useMemo(() => {
      if (meta && meta.touched && !isEmpty(meta.error)) {
        return meta.error;
      }
      return null;
    }, [meta]);

    const renderHelper = () => {
      const slots = [];

      if (help) {
        slots.push(<span key="form-helper">{help}</span>);
      }

      if (error && name) {
        let message = error;
        if (isObject(error)) {
          const [, firstMessage] = Object.entries(error)[0];
          message = firstMessage;
        }
        slots.push(<span key="form-explanation">{message}</span>);
      }
      return slots.length ? <>{slots}</> : null;
    };

    return (
      <Item
        className={layoutClasses}
        label={label}
        required={required}
        validateStatus={validateStatus}
        hasFeedback={hasFeedback}
        help={renderHelper()}
        tooltip={tooltip}
        layout={layout}>
        <WrappedComponent ref={ref} error={error} {...rest} />
      </Item>
    );
  });
};
